// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2fMz2","content":"styles_content__3HUre","checkbox":"styles_checkbox__APK6H","checkboxLabel":"styles_checkboxLabel__2nPxB"};